import { Localization } from "@viamap/viamap2-common";
import chroma from "chroma-js";
import { GlassButton } from "src/components/GlassButtons";

export function PLAAttributeColor(props: { value: unknown; label: string; readOnly?: boolean; onChange?: (value: string) => void }) {
   const value = props.value === undefined || props.value === null ? "" : String(props.value);
   const valid = value === "" || chroma.valid(value);
   const color = value && valid ? chroma(value).hex("rgb") : "#000000";
   if (props.readOnly || !props.onChange) return <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {value && valid && <i aria-hidden="true" style={{ display: "inline-block", width: 14, height: 14, backgroundColor: color, border: "1px solid #94a3b8" }} />}
      {value}
      {!valid && <span role="alert">{Localization.getText("Invalid color")}</span>}
   </span>;
   return <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <input type="color" aria-label={props.label} value={color} onChange={(event) => props.onChange?.(event.target.value)} />
      <span>{value || Localization.getText("None")}</span>
      {value && <GlassButton onClick={() => props.onChange?.("")}>{Localization.getText("Clear color")}</GlassButton>}
      {!valid && <span role="alert">{Localization.getText("Invalid color")}</span>}
   </span>;
}
